import instaclustrComponent from "./Components";

export class Component extends instaclustrComponent {
    constructor(name, node) {
        super(name, node);
    }
    init() {
        console.log(this.name);

        // Breakpoint references
        let sm = 576,
            md = 768,
            lg = 992,
            xl = 1200;

        // Viewport width helper function
        function viewport() {
            let e = window,
                a = 'inner';
            if (!('innerWidth' in window)) {
                a = 'client';
                e = document.documentElement || document.body;
            }
            return { width: e[ a + 'Width' ], height : e[ a + 'Height'] };
        }

        let vpWidth       = viewport().width;
        let headOffset= 230;

        let $stickyNav    = $('.component.component-archive-results-2024 .blog-cta-box');
        let $navContainer = $stickyNav.parent();
        let $navList      = $stickyNav.find('ul');
        let $navHeight    = $navList.height();
        let $navWidth     = $navContainer.width();
        //let $navOffset    = $stickyNav.offset().top; // nav's distance from top of window

        let $contents     = $('.sticky-nav-contents');
        let $bottom       = $('#bottomAnchor');
        let $bottomOffset = $bottom.offset();

        // TODO: Adapt this to the blog-cta-box
        function icStickyNav() {
            let $scrollTop = $(window).scrollTop(); // current distance from top of window
            if (vpWidth >= md) {
                if ($scrollTop + $navHeight > $bottomOffset - headOffset) {
                    $stickyNav.css({
                        'top'   : (($scrollTop + $navHeight - $bottomOffset) * -1)
                    });
                }
                else if ($scrollTop >= $navOffset - headOffset) {
                    $stickyNav.css({
                        'position' : 'fixed',
                        'top'      : '230px',
                        'width'    : $navWidth
                    });
                }
                else {
                    $stickyNav.css({
                        'position' : 'relative',
                        'top'      : '0',
                        'width'    : $navWidth
                    });
                }
            }
        }

        //icStickyNav();

        // Invoke nav check and scrollspy on scroll
        $(window).scroll(function() {
            //icStickyNav();
        });
    }
}